import * as React from "react";
import { TestHubView } from "TestManagement/Scripts/TFS.TestManagement.TestView";
import { registerLWPComponent } from "VSS/LWP";

export interface IGridViewProxyComponentProps {
    gridOption: GridOptions;
    selectedSuite?: any;
    plan?: any;
    testCaseIds?: any;
    columnOptions?: any;
    isDirtyCallback?: (isDirty: boolean) => void;
}

const enum GridOptions {
    CreateGrid = 1,
    EditGrid = 2,
    CloseGrid = 3
}

let testHubView: TestHubView = new TestHubView();
/**
 * Proxy component to render grid in test plans hub refresh.
 */
class GridViewProxyComponent extends React.Component<IGridViewProxyComponentProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        if(this.props.gridOption === GridOptions.CreateGrid) {
            // initial creation of grid view when define tab is rendered
            testHubView._createGridForHubRefresh();
        }
        else if(this.props.gridOption === GridOptions.EditGrid) {
            // show up grid view with selected test case ids
            testHubView._showGridForHubRefresh(this.props.plan, this.props.selectedSuite, this.props.testCaseIds, this.props.columnOptions, this.props.isDirtyCallback);
        }
        else {
            testHubView._closeGridForHubRefresh();
        }
    }
}

registerLWPComponent("grid-view-proxy-component", GridViewProxyComponent);
